module.exports = __webpack_public_path__ + "img/RS422+.d0e05b9b.png";